module.exports = "<a href = \"https://www.tripadvisor.rs/Restaurant_Review-g304080-d1173252-Reviews-Konoba_Feral-Herceg_Novi_Herceg_Novi_Municipality.html\" target=\"_blank\">\r\n    <img src=\"assets/images/header/trip-advisor-2014.png\"/>\r\n    <img src=\"assets/images/header/trip-advisor-2015.png\"/>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/trip-advisor/trip-advisor.component.html
// module id = 772
// module chunks = 1